import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { useAuthStore } from './auth'

function apiClient() {
  const auth = useAuthStore()
  const client = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: auth.accessToken
      ? { Authorization: `Bearer ${auth.accessToken}` }
      : {}
  })
  client.interceptors.response.use(
    res => res,
    async err => {
      if (err.response?.status === 401 && !err.config._retry) {
        err.config._retry = true
        await auth.silentRenew()
        if (auth.accessToken) {
          err.config.headers['Authorization'] = `Bearer ${auth.accessToken}`
          return client(err.config)
        }
      }
      return Promise.reject(err)
    }
  )
  return client
}

export const usePlayerStore = defineStore('player', () => {
  const profile = ref(null)
  const tokenTransactions = ref([])

  async function fetchProfile() {
    const { data } = await apiClient().get('/me')
    profile.value = data
  }

  async function saveProfile(payload) {
    await apiClient().patch('/me', payload)
    await fetchProfile()
  }

  async function fetchTokenTransactions() {
    const { data } = await apiClient().get('/me/token-transactions')
    tokenTransactions.value = data
  }

  async function topUpTokens(amount) {
    await apiClient().post('/me/tokens', { amount })
    await fetchProfile()
  }

  return { profile, tokenTransactions, fetchProfile, saveProfile, fetchTokenTransactions, topUpTokens }
})
